//import fire from '@/fire';
//import { decryptData } from '@/components4x/utils/utils4x';
import HttpHandlerService from '@/services/httpHandlerService';
import LoadSettingsService from './LoadSettingsService';

const DEFAULT_THEME_PALETTE = {
  primary: '#1e88e5',
  primaryDark: '#1565c0',
  primaryLight: '#e3f2fd',
  border: '#e5e7eb',
  text: '#1f2937',
  muted: '#64748b',
  success: '#2e9d43',
  warning: '#f97316'
};

const CLIENT_THEME_PALETTES = {
  '#c41230': {
    primary: '#c41230',
    primaryDark: '#9f1028',
    primaryLight: '#fbecef',
    border: '#e5e7eb',
    text: '#1f2937',
    muted: '#64748b',
    success: '#2e9d43',
    warning: '#f97316'
  }
};

function normalizeColor(color) {
  return typeof color === 'string' ? color.trim().toLowerCase() : '';
}

function getThemePalette(themeColor) {
  const color = normalizeColor(themeColor);
  return (
    CLIENT_THEME_PALETTES[color] || {
      ...DEFAULT_THEME_PALETTE,
      primary: color || DEFAULT_THEME_PALETTE.primary
    }
  );
}

function applyClientTheme(vuetify, palette) {
  const theme = {
    primary: palette.primary,
    info: palette.primary,
    success: palette.success,
    warning: palette.warning,
    accent: palette.primaryDark,
    default: palette.primaryDark
  };

  Object.assign(vuetify.framework.theme.themes.light, theme);
  Object.assign(vuetify.framework.theme.themes.dark, theme);

  if (document?.documentElement) {
    document.documentElement.style.setProperty('--gpr-primary', palette.primary);
    document.documentElement.style.setProperty('--gpr-primary-dark', palette.primaryDark);
    document.documentElement.style.setProperty('--gpr-primary-light', palette.primaryLight);
    document.documentElement.style.setProperty('--gpr-border', palette.border);
    document.documentElement.style.setProperty('--gpr-text', palette.text);
    document.documentElement.style.setProperty('--gpr-muted', palette.muted);
    document.documentElement.style.setProperty('--gpr-success', palette.success);
    document.documentElement.style.setProperty('--gpr-warning', palette.warning);
  }
}

/*async function loadPermissions(store) {
  const id = localStorage.getItem('lrd5qwlr674');
  if (id === null) return;

  const role = await store.getters.getRole;
  if (role === '') return;

  const ref = fire.firestore().collection('modules_auth');

  const response = await ref.where('roles', 'array-contains', role).get();

  // console.log('response', response.docs);

  if (response.empty) return;

  const permissions = [];

  response.forEach((doc) => {
    permissions.push(doc.data().code);
  });

  await store.dispatch('updatePermission', permissions);
  console.log(permissions);
}*/

async function loadSettings(store, vuetify) {
  /*const id = localStorage.getItem('lrd5qwlr674');
  if (id === null) return;

  const decryptId = decryptData(id);

  const config = await fire
    .firestore()
    .collection('users')
    .doc(decryptId)
    .get();

  if (!config.exists) return;

  // console.log(vuetify, vuetify);

  vuetify.framework.theme.dark = config.data().themedark;
  store.commit('SET_SIDEBAR_COLOR', config.data().sidebarcolor);
  store.commit('SET_THEME_COLOR', config.data().themecolor);
  await store.dispatch('updateRole', config.data().role);
  await store.dispatch('updateProfile', config.data().profile);*/

  /**
   *
   */

  const isLoginPage = window.location.pathname.includes('/auth/login');
  const token = localStorage.getItem('token');

  if (isLoginPage || token === null || token === '') {
    return;
  }

  const clearSession = async () => {
    localStorage.removeItem('token');
    localStorage.removeItem('lrd5qwlr674');
    localStorage.removeItem('iow5csjr398');
    localStorage.removeItem('nc4rhtcc976');
    localStorage.removeItem('k3rtxqdp234');
    localStorage.removeItem('oq1rcizm635');
    await store.dispatch('updateReset');
    window.location.href = process.env.VUE_APP_CLIENT_LOGIN_URL;
  };

  try {
    const http = new HttpHandlerService(new LoadSettingsService(), null, {
      token: true,
      name: 'token'
    });

    const res = await http.get().execResource('configuraciones');
    if (res[0].activo == 1) {
      const themePalette = getThemePalette(res[0].themecolor);

      vuetify.framework.theme.dark = Number(res[0].themedark);
      applyClientTheme(vuetify, themePalette);
      store.commit('SET_SIDEBAR_COLOR', res[0].sidebarcolor);
      store.commit('SET_THEME_COLOR', themePalette.primary);
      store.commit('SET_THEME_PALETTE', themePalette);
      await store.dispatch('updateProfile', res[0].permisos);
      await store.dispatch('updateRole', res[0].role);
      await store.dispatch('updatePermission', res[0].module_code);

      const res2 = await http.get().execResource('proyeccionMO');
      await store.dispatch('cargarProyeccionMO', res2);
    } else {
      const res = await http.get().execResource('cerrarSesion');
      if (res.status) {
        await clearSession();
      }
    }
  } catch (error) {
    if (error?.response?.status === 401 || error?.code === 401) {
      await clearSession();
      return;
    }

    throw error;
  }
}

//export { loadSettings, loadPermissions };
export { loadSettings };
